module.exports = __webpack_public_path__ + "img/web-link.b7a6e99f.svg";